// extracted by mini-css-extract-plugin
export default {"joinbutton":"JoiningButton_joinbutton__5hg0d","joiningbuttonscreencontainer":"JoiningButton_joiningbuttonscreencontainer__8P7K1","buttoncenter":"JoiningButton_buttoncenter__mK5OV"};